import { useMutation, useQueryClient } from '@tanstack/react-query';
import EventChecklistService, {
  ICreateEventChecklistParams,
} from '@clickersphere/core/services/EventChecklistService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import {
  EventChecklistQueryData,
  EVENT_CHECKLISTS_QUERY_KEY,
} from './useEventChecklists';

export function useCreateEventChecklist() {
  const queryClient = useQueryClient();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    isPending: createEventChecklistIsPending,
    mutateAsync: createEventChecklistAsync,
  } = useMutation({
    mutationFn: async (data: ICreateEventChecklistParams) => {
      const checklist = await EventChecklistService.create(data);
      return checklist as EventChecklistQueryData;
    },
    onSuccess: async (data) => {
      await queryClient.cancelQueries({
        queryKey: buildQueryKey(EVENT_CHECKLISTS_QUERY_KEY),
      });

      queryClient.setQueryData<EventChecklistQueryData[]>(
        buildQueryKey(EVENT_CHECKLISTS_QUERY_KEY),
        (old) => [...(old ?? []), data],
      );
    },
  });

  return {
    createEventChecklistAsync,
    createEventChecklistIsPending,
  };
}
